import React from "react";
import amit from "../images/amit.jpeg";
import areeba from "../images/areeba.jpeg";
import saurabh from "../images/saurabh.jpeg";

function Review() {
  return (
    <>
      <section id="testimonials" className="py-10 lg:py-20">
        <hr className="pt-5"></hr>
        <div className="container mx-auto">
          <p className="uppercase text-xl tracking-wider mb-8 text-gray-600 text-center">
            Words from our toppers
          </p>
          <div className="flex flex-col md:flex-row md:-mx-3">
            <div className="flex-1 px-3">
              <div
                className="p-12 rounded-lg border border-solid border-gray-200 mb-8"
                style={{ boxShadow: "0 10px 28px rgba(0,0,0,.08)" }}
              >
                <p className="mt-1">
                  Curiocode Solutions exceeded my expectations! Their virtual
                  internships are hands-on and practical, preparing IT students
                  with real-world skills. The certifications offered are
                  recognized and valued in the industry. Highly recommended!
                </p>
                <div className="flex items-center mt-8">
                  <img
                    className="w-12 h-12 mr-4 rounded-full"
                    src={amit}
                    alt="Amit"
                  />
                  <div>
                    <p>
                      <a
                        href="https://www.linkedin.com/in/amit-yadav-651182253/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Amit Yadav
                      </a>
                    </p>
                    <p className="text-sm text-gray-600">
                      Financer Intern at PNB
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1 px-3">
              <div
                className="p-12 rounded-lg border border-solid border-gray-200 mb-8"
                style={{ boxShadow: "0 10px 28px rgba(0,0,0,.08)" }}
              >
                <p className="mt-1">
                  They offer virtual internships that give IT students practical
                  experience. Their certifications are respected in the
                  industry. I highly recommend them!
                </p>
                <div className="flex items-center mt-8">
                  <img
                    className="w-12 h-12 mr-4 rounded-full"
                    src={saurabh}
                    alt="Saurabh"
                  />
                  <div>
                    <p>
                      <a
                        href="https://www.linkedin.com/in/saurabhmaurya45/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Saurabh Maurya
                      </a>
                    </p>
                    <p className="text-sm text-gray-600">
                      Web developent Intern at Techkmr
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1 px-3">
              <div
                className="p-12 rounded-lg border border-solid border-gray-200 mb-8"
                style={{ boxShadow: "0 10px 28px rgba(0,0,0,.08)" }}
              >
                <p className="mt-1">
                  Curiocode Solutions rocks! Their virtual internships are a
                  breeze and super helpful for IT students. Plus, their
                  certifications are legit and really boost your resume. Check
                  them out!
                </p>
                <div className="flex items-center mt-8">
                  <img
                    className="w-12 h-12 mr-4 rounded-full"
                    src={areeba}
                    alt="Areeba Shakil"
                  />
                  <div>
                    <p>
                      <a
                        href="https://www.linkedin.com/in/areeba-shakeel-a41513249/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Areeba Shakeel
                      </a>
                    </p>
                    <p className="text-sm text-gray-600">
                      Technicat Trainer at Digipodium
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Review;
